import { useState, useCallback } from "react"

export const useReviewNotes = () => {
  const [reviewNotes, setReviewNotes] = useState<Record<number, string>>({})
  const [globalNote, setGlobalNote] = useState("")

  const setItemNote = useCallback((itemId: number, value: string) => {
    setReviewNotes((prev) => ({
      ...prev,
      [itemId]: value,
    }))
  }, [])

  const getItemNote = useCallback((itemId: number): string => {
    return reviewNotes[itemId] || ""
  }, [reviewNotes])

  return {
    reviewNotes,
    globalNote,
    setGlobalNote,
    setItemNote,
    getItemNote
  }
}
